import React, { useState } from "react";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io"; // اضافه کردن آیکون برای حس تعامل بهتر

const questions = {
  q1: {
    question: "شما در کدام مرحله از مسیر حرفه‌ای خود هستید؟",
    options: {
      a: "راه‌اندازی کسب‌وکار",
      b: "رشد و توسعه برند",
      c: "توسعه صادرات و ورود به بازارهای جدید",
      d: "مشاور، مدیر یا متخصص حرفه‌ای",
    },
  },
  q2: {
    question: "مهم‌ترین هدف شما از شرکت در این بوت‌کمپ چیست؟",
    options: {
      a: "افزایش فروش و درآمد",
      b: "ساخت یا بازسازی برند شخصی یا سازمانی",
      c: "یادگیری هوش مصنوعی برای کسب‌وکار",
      d: "توسعه شبکه ارتباطی و همکاری‌های جدید",
    },
  },
  q3: {
    question: "در حال حاضر مهم‌ترین مانع شما چیست؟",
    options: {
      a: "کمبود مشتری و فروش",
      b: "نبود استراتژی برند و بازاریابی",
      c: "ضعف در استفاده از ابزارهای دیجیتال و هوش مصنوعی",
      d: "نبود شبکه ارتباطی و همکاری‌های مؤثر",
    },
  },
  q4: {
    question: "میانگین درآمد ماهانه شما یا کسب‌وکارتان در حال حاضر چقدر است؟",
    options: {
      a: "تا ۵۰ میلیون تومان",
      b: "۵۰ تا ۱۵۰ میلیون تومان",
      c: "۱۵۰ تا ۵۰۰ میلیون تومان",
      d: "بیش از ۵۰۰ میلیون تومان",
    },
  },
  q5: {
    question: "کدام حوزه برای شما بیشترین اولویت را دارد? ",
    options: {
      a: "برندسازی و بازاریابی",
      b: "تجارت و توسعه بازار",
      c: "هوش مصنوعی و اتوماسیون",
      d: "شبکه‌سازی و توسعه فردی",
    },
  },
  q6: {
    question: "تا چه اندازه از هوش مصنوعی در کسب‌وکار خود استفاده می‌کنید؟",
    options: {
      a: "هنوز شروع نکرده‌ام",
      b: "استفاده محدود دارم",
      c: "به‌صورت منظم استفاده می‌کنم",
      d: "هوش مصنوعی بخشی از مدل کسب‌وکار من است",
    },
  },
  q7: {
    question: "در ۱۲ ماه آینده، مهم‌ترین هدف شما چیست؟",
    options: {
      a: "رسیدن به اولین ۱۰۰ میلیون تومان درآمد ماهانه",
      b: "رشد ۲ برابری درآمد",
      c: "ورود به بازارهای بین‌المللی",
      d: "ساخت یک برند ماندگار",
    },
  },
  q8: {
    question: "ترجیح می‌دهید پس از بوت‌کمپ چگونه مسیر رشد خود را ادامه دهید؟",
    options: {
      a: "عضویت در جامعه شبکه هوش برتر",
      b: "منتورینگ و مشاوره تخصصی",
      c: "خدمات طراحی سایت، سئو و توسعه دیجیتال",
      d: "عضویت در سکوی تجارت بین‌الملل ویمهر",
    },
  },
  q9: {
    question: "چقدر برای سرمایه‌گذاری روی رشد شخصی و کسب‌وکار خود جدی هستید؟",
    options: {
      a: "در حال بررسی هستم",
      b: "آماده یادگیری هستم",
      c: "آماده اجرا و اقدام هستم",
      d: "آماده سرمایه‌گذاری و توسعه جدی هستم",
    },
  },
  q10: {
    question: "اگر بتوانید فقط یک نتیجه از این بوت‌کمپ به دست آورید، دوست دارید چه باشد؟",
    placeholder: "پاسخ خود را بنویسید...",
    fullName: "نام و نام خانوادگی",
    fullNamePlaceholder: "نام و نام خانوادگی خود را وارد کنید",
    phone: "شماره تلفن",
    phonePlaceholder: "شماره تلفن خود را وارد کنید",
  },
};

const getAnswerText = (key, value) => {
  const question = questions[key];
  if (!question) return value;
  if (!question.options) return value;
  return question.options[value] || value;
};

// کامپوننت اختصاصی برای هر کاربر به صورت آکاردئون
const UserAccordionItem = ({ user }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden transition-all duration-300">
      {/* هدر آکاردئون (بخش کلیک‌خور) */}
      <div
        className="p-5 flex flex-col sm:flex-row sm:items-center justify-between gap-4 cursor-pointer hover:bg-gray-50 transition-colors select-none"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
          <h2 className="font-bold text-gray-800 text-lg">{user.fullName}</h2>
          <span className="text-sm text-gray-500 bg-gray-100 px-3 py-1 rounded-full dir-ltr">
            {user.phone}
          </span>
          <span className="text-sm text-gray-400">
            {new Intl.DateTimeFormat("fa-IR", { dateStyle: "medium" }).format(new Date(user.createdAt))}
          </span>
        </div>
        <div className="text-gray-500 self-end sm:self-center">
          {isOpen ? <IoIosArrowUp size={22} /> : <IoIosArrowDown size={22} />}
        </div>
      </div>

      {/* محتوای سوال و جواب‌ها که با کلیک باز/بسته می‌شود */}
      {isOpen && (
        <div className="p-5 border-t border-gray-100 bg-gray-50/50 space-y-4 animate-fadeIn">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {user.answers?.map((answer) => (
              <div key={answer._id} className="border border-gray-100 rounded-lg p-4 bg-white shadow-sm">
                <p className="font-medium text-gray-700 text-sm mb-2">
                  {questions[answer.key]?.question}
                </p>
                <p className="text-blue-600 font-semibold text-sm bg-blue-50/50 p-2 rounded border border-blue-100/50">
                  {getAnswerText(answer.key, answer.value)}
                </p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const QandAUsers = ({ data }) => {
  return (
    <div className="space-y-4 max-w-5xl mx-auto p-4 dir-rtl">
      {data?.map((user) => (
        <UserAccordionItem key={user._id} user={user} />
      ))}
    </div>
  );
};

export default QandAUsers;